import { styled } from '@mui/material/styles';

export const MenuContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(1),
    maxHeight: '450px',
    display: 'flex',
    flexDirection: 'column',
}));

export const SearchInputContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
}));

export const AppliedTagsContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1),
    gap: theme.spacing(0.5),
}));

export const TagsListContainer = styled('div')(() => ({
    maxHeight: '200px',
    overflowY: 'auto',
}));

export const TagRow = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));
